import { useEffect } from 'react';
import { useTagsQuery } from '../queries';
import { useTagsStore } from '../state';
import { buildTreeTags } from '../utils';

export const useSyncTagsToStore = () => {
  const {
    tags: prevTags,
    treeTags: prevTreeTags,
    setTreeTags,
    setTags
  } = useTagsStore();

  const { data: tags, ...rest } = useTagsQuery();

  useEffect(() => {
    if (!tags || tags === prevTags) {
      return;
    }

    setTags(tags);

    const treeTags = buildTreeTags(tags, prevTreeTags);

    setTreeTags(treeTags);
  }, [prevTags, prevTreeTags, setTags, setTreeTags, tags]);

  return { tags, ...rest };
};
